import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { trackEvent } from 'dibs-tracking';
import classnames from 'classnames';

import styles from './LinkColumnItem.scss';

class LinkColumnItem extends Component {
    constructor(props) {
        super(props);

        this.trackClick = this.trackClick.bind(this);
    }

    trackClick() {
        const { trackingLabel } = this.props;

        const category = 'navigation';
        const action = 'footer navigation click';
        const label = trackingLabel.trim().toLowerCase();

        trackEvent({ category, action, label });
    }

    render() {
        const { target, href, dataTn, formattedMessage, badgeText, isLegalLink } = this.props;

        const doNotShowPrivacyPolicyAlerts = true;
        const shouldShowBadge = !!badgeText && !doNotShowPrivacyPolicyAlerts;

        return (
            <div className={classnames(styles.item, { [styles.isLegalLink]: !!isLegalLink })}>
                {href ? (
                    <a
                        className={styles.link}
                        target={target}
                        href={href}
                        onClick={this.trackClick}
                        data-tn={dataTn}
                        rel="noopener"
                    >
                        {formattedMessage}
                        {shouldShowBadge && (
                            <div className={styles.badge}>
                                <div className={styles.badgeInner}>{badgeText}</div>
                            </div>
                        )}
                    </a>
                ) : (
                    formattedMessage
                )}
            </div>
        );
    }
}

LinkColumnItem.propTypes = {
    styles: PropTypes.object,
    href: PropTypes.string,
    trackingLabel: PropTypes.string,
    target: PropTypes.string,
    dataTn: PropTypes.string,
    formattedMessage: PropTypes.element.isRequired,
    badgeText: PropTypes.element,
    isLegalLink: PropTypes.bool,
};

export default LinkColumnItem;
